import { render, staticRenderFns } from "./tickets-data.vue?vue&type=template&id=28df9708"
import script from "./tickets-data.vue?vue&type=script&lang=js"
export * from "./tickets-data.vue?vue&type=script&lang=js"
import style0 from "./tickets-data.vue?vue&type=style&index=0&id=28df9708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports